import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import MobileFloatingCTA from "@/components/MobileFloatingCTA";
import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Refund from "@/pages/Refund";
import GstData from "@/pages/GstData";
import McaData from "@/pages/McaData";
import GstDatabase from "@/pages/GstDatabase";
import McaDataHub from "@/pages/McaDataHub";
import McaMonth from "@/pages/McaMonth";
import GstDataHub from "@/pages/GstDataHub";
import GstMonth from "@/pages/GstMonth";
import BusinessOwners from "@/pages/BusinessOwners";
import CompanyDirectors from "@/pages/CompanyDirectors";
import BusinessLoan from "@/pages/BusinessLoan";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Nav />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/databases" element={<Categories />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/gst-sales-purchase-data" element={<GstData />} />
            <Route path="/mca-company-database" element={<McaData />} />
            <Route path="/gst-database" element={<GstDatabase />} />
            <Route path="/mca-data" element={<McaDataHub />} />
            <Route path="/mca-data/:slug" element={<McaMonth />} />
            <Route path="/gst-data" element={<GstDataHub />} />
            <Route path="/gst-data/:slug" element={<GstMonth />} />
            <Route path="/business-owners-database" element={<BusinessOwners />} />
            <Route path="/company-directors-database" element={<CompanyDirectors />} />
            <Route path="/business-loan-database" element={<BusinessLoan />} />
          </Routes>
        </main>
        <Footer />
        <MobileFloatingCTA />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
